import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { JhiLanguageService } from 'ng-jhipster';
import * as moment from 'moment-timezone';
import { StateStorageService } from '../auth/state-storage.service';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(
      private languageService: JhiLanguageService,
      private stateStorageService: StateStorageService) {
  }

  transform(value: any, pattern: string, tz: string): any {
    const datePipe: DatePipe = new DatePipe(this.languageService.currentLang);
    let output: Date;
    if (value) {
        // By default the timezone is Europe Paris
        let timeZoneFromStorage = this.stateStorageService.getCurrentTimezone();
        let dateStr = moment.tz(value, timeZoneFromStorage ? timeZoneFromStorage : 'Europe/Paris' ).format('YYYY-MM-DD HH:mm');
        output = new Date(dateStr.replace(/-/g, '/'));
    } else {
        output = value;
    }
    return datePipe.transform(output, pattern);
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/pipes/localized-date.pipe.ts